export default class MenuDropdown {
  constructor(element) {
    this.el = element;
    this.checkbox = this.el.querySelector("input");
    this.svg = this.el.querySelector("label svg");
    this.dropdown = this.el.querySelector("[data-dropdown]");
    this.setTabState = this.setTabState.bind(this);
    this.init()
  }
  
  init() {
    if (this.checkbox){      
      this.checkbox.addEventListener('change', e =>{
        this.setTabState()
      })
    }
    window.addEventListener('scroll', () => {
      if (this.checkbox.checked){
        this.checkbox.checked = false;
        this.setTabState();
      }
    }, {passive:true})
    window.addEventListener('click', (e) => {
      if (!this.el.contains(e.target)){
        this.checkbox.checked = false;
        this.setTabState();
      }
    })
  }

  setTabState(){
    let dropdownlinks = this.dropdown.querySelectorAll("a");
    if (this.checkbox.checked){
      this.svg.classList.add("rotate");
      if (dropdownlinks){
        dropdownlinks.forEach(element => {
          element.tabIndex = 0;
        });
      }
    } else{
      this.svg.classList.remove("rotate");
      if (dropdownlinks){
        dropdownlinks.forEach(element => {
          element.tabIndex = -1;
        });
      }
  }
    }
  }

